import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PwaInstallService } from 'src/app/core/services/pwa-install.service';
import { Observable, combineLatest, map } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-pwa-install-banner',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
  templateUrl: './pwa-install-banner.component.html',
  styleUrls: ['./pwa-install-banner.component.scss']
})
export class PwaInstallBannerComponent implements OnInit {
  showInstallBanner$: Observable<boolean>;
  private dismissedSubject = new BehaviorSubject<boolean>(false);

  constructor(private pwaInstallService: PwaInstallService) {
    // Combine canInstall$ with dismissed state
    this.showInstallBanner$ = combineLatest([
      this.pwaInstallService.canInstall$,
      this.dismissedSubject.asObservable()
    ]).pipe(
      map(([canInstall, dismissed]) => canInstall && !dismissed)
    );
  }

  ngOnInit(): void {
    // Check if banner was previously dismissed
    const wasDismissed = localStorage.getItem('pwa-install-dismissed') === 'true';
    this.dismissedSubject.next(wasDismissed);
  }

  async installApp(): Promise<void> {
    const installed = await this.pwaInstallService.promptInstall();
    if (installed) {
      console.log('PWA installed successfully');
    }
  }

  dismissBanner(): void {
    localStorage.setItem('pwa-install-dismissed', 'true');
    this.dismissedSubject.next(true);
  }
}
